import React, { useEffect } from 'react';
import './TrustSafety.css';
import { FaCheck } from 'react-icons/fa';
import deliveryImage from '../../assets/Media2.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

const TrustSafety = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="ts-modern-container">
      <div className="ts-content-grid">
        {/* Image Section - Now on left */}
        <div className="ts-image-block" data-aos="fade-right" data-aos-delay="300">
          <div className="ts-image-frame">
            <img
              src={deliveryImage}
              alt="Trust and Safety Assurance"
              className="ts-main-image"
            />
            <div className="ts-image-overlay"></div>
          </div>
        </div>

        {/* Text Content - Now on right */}
        <div className="ts-text-block">
          <h2 className="ts-main-heading" data-aos="fade-left" data-aos-delay="100">
            Our Commitment to <span className="ts-highlight">Trust & Safety</span>
          </h2>
          
          <div className="ts-features-grid">
            <div className="ts-feature-card" data-aos="zoom-in" data-aos-delay="200">
              <div className="ts-icon-circle">
                <FaCheck className="ts-feature-icon" />
              </div>
              <h3 className="ts-feature-title">Profile Verification</h3>
              <p className="ts-feature-desc">Rigorous checks for all farmers and buyers</p>
            </div>

            <div className="ts-feature-card" data-aos="zoom-in" data-aos-delay="300">
              <div className="ts-icon-circle">
                <FaCheck className="ts-feature-icon" />
              </div>
              <h3 className="ts-feature-title">Digital Contracts</h3>
              <p className="ts-feature-desc">Legally binding agreements for all transactions</p>
            </div>

            <div className="ts-feature-card" data-aos="zoom-in" data-aos-delay="400">
              <div className="ts-icon-circle">
                <FaCheck className="ts-feature-icon" />
              </div>
              <h3 className="ts-feature-title">Harvest Guidance</h3>
              <p className="ts-feature-desc">Expert advice for post-harvest handling</p>
            </div>

            <div className="ts-feature-card" data-aos="zoom-in" data-aos-delay="500">
              <div className="ts-icon-circle">
                <FaCheck className="ts-feature-icon" />
              </div>
              <h3 className="ts-feature-title">Market Analytics</h3>
              <p className="ts-feature-desc">Real-time price trends and insights</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSafety;